{
  "title": "Ice Storm",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level evocation",
  "level": 4,
  "castingTime": "1 action",
  "range": "300 feet",
  "components": "V, S, M (a pinch of dust and a few drops of water)",
  "duration": "Instantaneous",
  "description": [
    "A hail of rock-hard ice pounds to the ground in a 20-foot-radius, 40-foot-high cylinder centered on a point within range. Each creature in the cylinder must make a Dexterity saving throw. A creature takes 2d8 bludgeoning damage and 4d6 cold damage on a failed save, or half as much damage on a successful one.",
    "Hailstones turn the storm’s area of effect into difficult terrain until the end of your next turn.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, the bludgeoning damage increases by 1d8 for each slot level above 4th."
  ],
  "spellLists": ["druid", "eldritch-knight", "sorcerer", "wizard"]
}
